import { getAxiosClient } from "../../axios-client";
import { DeleteWarehousesImagesBody, DeleteWarehousesImagesResponse } from "./types";

const axiosClient = getAxiosClient();
export const deleteWarehousesImage = async (body: DeleteWarehousesImagesBody) => {
    return await axiosClient.ax
    .delete<DeleteWarehousesImagesResponse>("/WarehousesImages/DeleteImage", {data:body})
  };
  
